import { setCookie, getCookie } from '../helpers/cookie';

const cookieLifetime = 365;
const cookieInteractedName = 'ico-cookie-interacted';
const cookieAcceptedName = 'ico-cookie-accepted';
const bar = document.querySelector('.cookie-bar');

if (bar) {
    const agree = bar.querySelector('.js-cookie-agree');
    const disagree = bar.querySelector('.js-cookie-disagree');
    const hide = bar.querySelector('.js-cookie-close');

    if (getCookie(cookieInteractedName) !== "1") {
        bar.classList.add('active');
    }

    if (agree) {
        agree.addEventListener('click', () => {
            setCookie(cookieAcceptedName, 1, cookieLifetime);
            close(cookieLifetime);
        });
    }

    if (disagree) {
        disagree.addEventListener('click', () => {
            //setCookie(cookieAcceptedName, 0, cookieLifetime);
            close(cookieLifetime);
        });
    }

    if (hide) {
        hide.addEventListener('click', () => {
            //setCookie(cookieAcceptedName, 0, false);
            close(false);
        });
    }
}

function close(cookieLifetime) {
    setCookie(cookieInteractedName, 1, cookieLifetime);
    bar.classList.remove('active');
}
